import axios from 'axios'
import {router} from '../router/index'

/* const axiosConfig = {
  baseURL: '/api/v1/',
  timeout: 100000
} */

var axiosConfig
if (process.env.NODE_ENV === "production") {
  axiosConfig = {
    baseURL: '/api/v1/',
    timeout: 100000
  }
} else {
  axiosConfig = {
    baseURL: 'http://localhost:8300/',
    timeout: 100000
  }
}

const http = axios.create(axiosConfig)
http.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('token')}`

http.interceptors.response.use(
  (config) => {
    config.headers['Authorization'] = 'Bearer ' + localStorage.getItem('token')
    return config
  },
  (error) => {
    if (error.response.status === 401) {
      // sign out remove token
      router.push('/auth/sign-in')
    }
    return Promise.reject(error)
  })

export default http
